import React from 'react';

import { useLocale } from '@adsk/alloy-react-locale';
import SearchField from '@adsk/alloy-react-search-field';
import theme from '@adsk/alloy-react-theme';

function ScheduleSearchField({
  searchExpression,
  onSearchChange,
  disabled,
}: {
  searchExpression: string;
  onSearchChange: (search: string) => void;
  disabled: boolean;
}) {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return (
    <div>
      <SearchField
        style={{
          maxWidth: 225,
          minWidth: 200,
          'input:disabled': {
            background: theme.colors.white,
          },
        }}
        placeholder={T.translate('SEARCH')?.toString()}
        value={searchExpression ?? ''}
        onChange={onSearchChange}
        disabled={disabled}
      />
    </div>
  );
}

export default ScheduleSearchField;
